import type { IExtractParams } from "../types";

import { generatePath } from "@routes/generatePath";
import type { IRole } from "@/interfaces";
import type { ID } from "@constants";

const changePasswordRoute =
  "/userManagement/users/changeUserPassword/:role/:id";

const localAdminViewRoute = "/userManagement/local-admin/view/:id";
const localAdminEditRoute = "/userManagement/local-admin/edit/:id";
const localAdminCreateRoute = "/userManagement/local-admin/create";

const adminViewRoute = "/userManagement/admin/view/:id";
const adminEditRoute = "/userManagement/admin/edit/:id";
const adminCreateRoute = "/userManagement/admin/create";

const doctorViewRoute = "/userManagement/doctor/view/:id";

export type IDoctorViewParams = IExtractParams<typeof doctorViewRoute>;
const doctorEditRoute = "/userManagement/doctor/edit/:id";

export type IDoctorEditParams = IExtractParams<typeof doctorEditRoute>;

const doctorEditFacilityRoute = "/userManagement/doctor/facility/edit/:id";

export type IDoctorEditFacilityParams = IExtractParams<
  typeof doctorEditFacilityRoute
>;

const doctorCreateRoute = "/userManagement/doctor/create";

export type IDoctorCreateParams = IExtractParams<typeof doctorCreateRoute>;

const staffViewRoute = "/userManagement/staff/view/:id";
const staffEditRoute = "/userManagement/staff/edit/:id";
const staffCreateRoute = "/userManagement/staff/create";

const patientViewRoute = "/userManagement/patient/view/:id";
const patientEditRoute = "/userManagement/patient/edit/:id";
const patientCreateRoute = "/userManagement/patient/create";

const roleManagementRoute = "/userManagement/roleManagement/:userId/:role";

export const path = {
  users: {
    route: "/userManagement/users",
    link: () => path.users.route,
  },
  changePassword: {
    route: changePasswordRoute,
    link: (id: string, role: IRole) =>
      generatePath(changePasswordRoute, { role, id }),
  },
  localAdmin: {
    route: "/userManagement/local-admin",
    link: () => path.localAdmin.route,
  },
  localAdminView: {
    route: localAdminViewRoute,
    link: (id: string) => generatePath(localAdminViewRoute, { id }),
  },
  localAdminEdit: {
    route: localAdminEditRoute,
    link: (id: string) => generatePath(localAdminEditRoute, { id }),
  },
  localAdminCreate: {
    route: localAdminCreateRoute,
    link: () => generatePath(localAdminCreateRoute),
  },
  admin: {
    route: "/userManagement/admin",
    link: () => path.admin.route,
  },
  adminView: {
    route: adminViewRoute,
    link: (id: string) => generatePath(adminViewRoute, { id }),
  },
  adminEdit: {
    route: adminEditRoute,
    link: (id: string) => generatePath(adminEditRoute, { id }),
  },
  adminCreate: {
    route: adminCreateRoute,
    link: () => generatePath(adminCreateRoute),
  },
  doctor: {
    route: "/userManagement/doctor",
    link: () => path.doctor.route,
  },
  doctorView: {
    route: doctorViewRoute,
    link: (id: string) => generatePath(doctorViewRoute, { id }),
  },
  doctorEdit: {
    route: doctorEditRoute,
    link: (id: string) => generatePath(doctorEditRoute, { id }),
  },
  doctorEditFacility: {
    route: doctorEditFacilityRoute,
    link: (id: string) => generatePath(doctorEditFacilityRoute, { id }),
  },
  doctorCreate: {
    route: doctorCreateRoute,
    link: () => generatePath(doctorCreateRoute),
  },
  staff: {
    route: "/userManagement/staff",
    link: () => path.staff.route,
  },
  staffView: {
    route: staffViewRoute,
    link: (id: string) => generatePath(staffViewRoute, { id }),
  },
  staffEdit: {
    route: staffEditRoute,
    link: (id: string) => generatePath(staffEditRoute, { id }),
  },
  staffCreate: {
    route: staffCreateRoute,
    link: () => generatePath(staffCreateRoute),
  },
  patient: {
    route: "/userManagement/patient",
    link: () => path.patient.route,
  },
  patientView: {
    route: patientViewRoute,
    link: (id: string) => generatePath(patientViewRoute, { id }),
  },
  patientEdit: {
    route: patientEditRoute,
    link: (id: string) => generatePath(patientEditRoute, { id }),
  },
  patientCreate: {
    route: patientCreateRoute,
    link: () => generatePath(patientCreateRoute),
  },
  roleManagement: {
    route: roleManagementRoute,
    link: (id: ID, role: IRole) =>
      generatePath(roleManagementRoute, { role, userId: id }),
  },
};
